module.exports = "<div>\n\n    <div class=\"dashboard-content\">\n        <div ui-view=\"dashboard.body.content\"></div>\n    </div>\n\n    <div ui-view=\"dashboard.body.tour.abstract\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/controllers/dashboard/body/body.html
// module id = Qc0x
// module chunks = 0